module.exports = __webpack_public_path__ + "img/bg-guarantee.8484efde.png";